import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from 'redux/store'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import url from 'libraries/front-end-core/core/url'
import CompactSwitch from 'components/CompactSwitch'
import { SEARCH, SMART_SEARCH } from 'constants/controllers'
import { setSmartSearchEnabled } from 'redux/actions'
import selectController from 'redux/selectors/selectController'
import selectCurrentSearchType from 'redux/selectors/selectCurrentSearchType'
import selectFlavour from 'redux/selectors/selectFlavour'
import selectHasSmartFeatures from 'redux/selectors/selectHasSmartFeatures'
import selectSearchQuery from 'redux/selectors/selectSearchQuery'
import { selectSmartSearchEnabled } from 'redux/selectors/selectSmartSearchEnabled'
import { pushEvent } from 'services/AnalyticsService'

export default function SmartSearchSwitch (): JSX.Element {
  const dispatch = useDispatch<AppDispatch>()
  const hasSmartSearch = useSelector(selectHasSmartFeatures)
  const enabled = useSelector(selectSmartSearchEnabled)
  const query = useSelector(selectSearchQuery)
  const controller = useSelector(selectController)
  const flavour = useSelector(selectFlavour)
  const currentSearchType = useSelector(selectCurrentSearchType)

  const isLoading = typeof hasSmartSearch !== 'boolean'
  const isSmartSearchRoute = controller === SMART_SEARCH
  const checked = isSmartSearchRoute ? true : enabled
  const isDisabled = isLoading

  const tooltip = isLoading
    ? 'Checking smart search access...'
    : hasSmartSearch
      ? 'Turn on for better results. Turn off for the traditional search'
      : 'Smart search is not available for this account.'

  const handleToggle = (_: unknown, checked: boolean): void => {
    if (!hasSmartSearch || isLoading) return
    dispatch(setSmartSearchEnabled(checked))
    if ((controller === SEARCH && currentSearchType === 'qa') || controller === SMART_SEARCH) {
      const parameters = { flavour, searchType: 'qa' }
      const queryParameters = { q: query.q, aol: query.aol }
      const isSmartSearch = controller === SMART_SEARCH
      const nextController = isSmartSearch ? SEARCH : SMART_SEARCH
      pushEvent({
        action: 'Input',
        category: isSmartSearch ? 'Search' : 'SmartSearch',
        label: `[QA-${flavour.toUpperCase()}] ${String(query.q)}`
      })
      replaceUrl(url(nextController, parameters, queryParameters))
    }
  }

  return (
    <CompactSwitch
      tooltip={tooltip}
      label='SmartSearch'
      checked={checked}
      onChange={handleToggle}
      disabled={isDisabled}
      data-event-category='Smart Search'
      data-event-action={checked ? 'Off' : 'On'}
    />
  )
}
